// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".linkstyle{font-size:12px;font-weight:400;text-decoration:underline;color:#009688;cursor:pointer}", ""]);
// Exports
module.exports = exports;
